import React from 'react';
import {
  Box,
  Card,
  CardContent,
  Typography,
  Grid,
  Avatar,
  LinearProgress
} from '@mui/material';
import {
  Assessment,
  Agriculture,
  TrendingUp,
  BarChart,
  NotificationsActive
} from '@mui/icons-material';
import { useQuery } from 'react-query';
import axios from 'axios';

const Censo = () => {
  const { data: stats, isLoading } = useQuery(['dashboard', 'stats'], async () => {
    const res = await axios.get('/api/dashboard/stats');
    return res.data;
  });

  if (isLoading) return <Box sx={{ p: 4, mt: 8 }}><LinearProgress /></Box>;

  // Map species to counts
  const speciesCounts = stats?.censo?.reduce((acc, curr) => {
    acc[curr.especie] = parseInt(curr.count);
    return acc;
  }, { bovino: 0, ovino: 0, caprino: 0 }) || { bovino: 0, ovino: 0, caprino: 0 };

  const total = stats?.totalAnimales || 494;

  return (
    <Box sx={{ p: 3, mt: 8 }}>
      <Typography variant="h4" sx={{ fontWeight: 'bold', mb: 3 }}>
        Censo de Explotación
      </Typography>
      
      <Grid container spacing={3}>
        <Grid item xs={12} md={3}>
          <Card>
            <CardContent sx={{ textAlign: 'center' }}>
              <Avatar sx={{ bgcolor: '#059669', width: 60, height: 60, mx: 'auto', mb: 2 }}>
                <Agriculture sx={{ fontSize: 30 }} />
              </Avatar>
              <Typography variant="h3" sx={{ fontWeight: 'bold', color: '#059669' }}>
                {total}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Total Animales
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={3}>
          <Card>
            <CardContent sx={{ textAlign: 'center' }}>
              <Typography variant="h3" sx={{ fontWeight: 'bold', color: '#10b981' }}>
                {speciesCounts.bovino}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Bovinos
              </Typography>
              <LinearProgress variant="determinate" value={(speciesCounts.bovino / total) * 100} sx={{ mt: 2 }} />
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={3}>
          <Card>
            <CardContent sx={{ textAlign: 'center' }}>
              <Typography variant="h3" sx={{ fontWeight: 'bold', color: '#f59e0b' }}>
                {speciesCounts.ovino}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Ovinos
              </Typography>
              <LinearProgress variant="determinate" value={(speciesCounts.ovino / total) * 100} sx={{ mt: 2 }} />
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={3}>
          <Card>
            <CardContent sx={{ textAlign: 'center' }}>
              <Typography variant="h3" sx={{ fontWeight: 'bold', color: '#ef4444' }}>
                {speciesCounts.caprino}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Caprinos
              </Typography>
              <LinearProgress variant="determinate" value={(speciesCounts.caprino / total) * 100} sx={{ mt: 2 }} />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Censo;
